/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1AssetState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_ASSET_STATE_ENTITY_NAME = 'ixc.assets.v1.Asset';
export const ixcAssetsV1AssetStateEntity = new schema.Entity<IxcAssetsV1AssetState>(IXC_ASSETS_V1_ASSET_STATE_ENTITY_NAME, {}, { idAttribute: 'assetId' });

